import { useEffect, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { createIcons, icons } from 'lucide';
import './../App.css';
import './../AQWpackages.css';
import SEO from '../SEO';

const Gallery = () => {
  const navigate = useNavigate();

  useLayoutEffect(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  useEffect(() => {
    createIcons({ icons });
  }, []);

  return (
    <div style={{ paddingTop: 64 }}>

      {/* Banner */}
      <div style={{
        position: 'relative', width: '100%', overflow: 'hidden',
        backgroundImage: 'url(/images/banners_AQW_page_gallery.webp)',
        backgroundSize: 'cover', backgroundPosition: 'center',
        padding: '64px 48px 56px',
        minHeight: 360,
        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
      }}>
        <div style={{
          position: 'absolute', inset: 0, pointerEvents: 'none',
          background: 'linear-gradient(to top, rgba(10,10,12,0.75) 0%, rgba(10,10,12,0.35) 50%, rgba(10,10,12,0.15) 100%)',
        }} />
        <button
          className="back-home-btn"
          onClick={() => navigate('/')}
          style={{
            position: 'absolute', top: 20, left: 50, zIndex: 2,
            background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.25)',
            cursor: 'pointer', alignItems: 'center', gap: 8,
            color: '#fff', fontSize: 13, padding: '6px 14px', borderRadius: 8,
          }}
        >
          <i data-lucide="arrow-left" style={{ width: 16, height: 16 }} /> Back to Home
        </button>
        <div style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
          <p style={{
            fontSize: 11, fontWeight: 700, letterSpacing: '0.18em',
            textTransform: 'uppercase', color: '#9ED3CD',
            margin: '0 0 12px', fontFamily: "'JetBrains Mono', monospace",
          }}>// clients</p>
          <h1 style={{ margin: '0 0 14px' }}>Clients</h1>
          <p style={{ color: 'var(--muted)', fontSize: 15, margin: 0 }}>
            Our clients, sponsors & the team behind AquaWARE
          </p>
        </div>
      </div>

      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '56px 24px' }}>

        {/* Our clients and sponsors */}
        <div style={{ marginBottom: 80 }}>
          <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#FFAD60', margin: '0 0 8px', fontFamily: "'JetBrains Mono', monospace" }}>// partners</p>
          <h2 style={{ fontSize: 'clamp(22px, 3vw, 32px)', fontWeight: 400, margin: '0 0 32px', color: 'var(--text)' }}>Our Clients & Sponsors</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 20 }}>
            {[
              { src: '/logos/baring_logo.png', alt: 'Baring' },
              { src: '/logos/mowi_logo.png', alt: 'Mowi' },
              { src: '/logos/grieg_seafood_logo.png', alt: 'Grieg Seafood' },
              { src: '/logos/gaia_salmon_logo.png', alt: 'Gaia Salmon' },
              { src: '/logos/salmones_austral_logo.png', alt: 'Salmones Austral' },
              { src: '/logos/skattefunn_logo.svg', alt: 'Skattefunn' },
              { src: '/logos/fhf_logo.png', alt: 'FHF' },
            ].map((logo) => (
              <div key={logo.alt} className="plan-card" style={{
                padding: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 120,
              }}>
                <img
                  src={logo.src}
                  alt={logo.alt}
                  style={{ maxWidth: '100%', maxHeight: 70, objectFit: 'contain', filter: 'brightness(0) invert(1)', opacity: 0.7 }}
                />
              </div>
            ))}
          </div>
        </div>


      </div>
    </div>
  );
};

export default Gallery;
